export interface IQuery { }

export class ManageProjectPlansPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ManageProjectPlansPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string

	constructor (workspaceId: number, tchProjectId: number, projectId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ManageProjectPlansPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectCapexQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectCapexQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectCapexQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectExpenseAllocationsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectExpenseAllocationsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectExpenseAllocationsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectExpenseSavingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectExpenseSavingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectExpenseSavingsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectMarginsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectMarginsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectMarginsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPhasesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPhasesQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPhasesQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPlanListQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanListQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string

	constructor (workspaceId: number, tchProjectId: number, projectId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanListQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPlanPnlQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanPnlQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	PnlId: string | null
	ApplyBenefitsConfidenceFactor: boolean
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, pnlId: string | null, applyBenefitsConfidenceFactor: boolean, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.PnlId = pnlId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanPnlQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPlanSettingsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanSettingsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanSettingsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPlanSummaryPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanSummaryPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectPlanSummaryPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectResourceAllocationsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceAllocationsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceAllocationsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectResourceSavingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceSavingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceSavingsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectResourceUnitCostsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceUnitCostsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectResourceUnitCostsQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectRevenuesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectRevenuesQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ProjectId: string
	ProjectPlanId: string | null
	Granularity: any | null
	Denomination: any | null

	constructor (workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string | null, granularity: any | null, denomination: any | null)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlans.Queries.ProjectRevenuesQueryV1, TCh.Domain.Quest'
	}

}

